import React from 'react';

const NewsTitle = () => {
    return (
        <div className="title">
            <h2>Blog Title 1</h2>
        </div>
    );
};

export default NewsTitle;
